import { StyleSheet } from 'aphrodite';
import { THEME } from '../Theme/theme';

export const s = StyleSheet.create({
	root: {
		display: 'inline-flex',
		border: `1px solid ${THEME.colors.primary.main}`,
		borderRadius: THEME.common.borderRadius,
		overflow: 'hidden',
		width: 'fit-content',
	},
	rootVertical: {
		flexDirection: 'column' as const,
	},
	rootSidebar: {
		border: 'none',
		borderRadius: 0,
		overflow: 'visible',
		width: '100%',
		gap: THEME.spacing.xs / 4,
	},
	item: {
		flex: 1,
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		whiteSpace: 'nowrap',
		padding: '10px 16px',
		fontSize: THEME.typography.fontSizes.sm,
		fontWeight: THEME.typography.fontWeights.bold,
		fontFamily: THEME.typography.fontFamilies.lexend,
		color: THEME.colors.primary.main,
		background: THEME.colors.background.light,
		border: 'none',
		borderRight: `1px solid ${THEME.colors.primary.main}`,
		cursor: 'pointer',
		userSelect: 'none',
		transition: 'background 0.15s',
		':last-child': {
			borderRight: 'none',
		},
		':hover:not([data-pressed]):not(:disabled)': {
			background: THEME.colors.hover.light,
		},
		':is([data-pressed])': {
			background: THEME.colors.primary.light,
		},
		':disabled': {
			opacity: 0.5,
			pointerEvents: 'none',
			cursor: 'default',
		},
	},
	itemVertical: {
		borderRight: 'none',
		borderBottom: `1px solid ${THEME.colors.primary.main}`,
		':last-child': {
			borderBottom: 'none',
		},
	},
	// Compact variant for dense chrome (e.g. an inbox panel header) where the default 40px control
	// would tower over neighbouring controls.
	itemSmall: {
		padding: '5px 12px',
		fontSize: THEME.typography.fontSizes.xs,
	},
	itemSidebar: {
		flex: 'none',
		justifyContent: 'flex-start',
		width: '100%',
		padding: '9px 12px',
		borderRight: 'none',
		borderBottom: 'none',
		borderRadius: THEME.common.borderRadius,
		fontFamily: 'inherit',
		fontWeight: THEME.typography.fontWeights.standard,
		color: THEME.colors.text.main,
		background: 'transparent',
		':last-child': {
			borderBottom: 'none',
		},
		':hover:not([data-pressed]):not(:disabled)': {
			background: THEME.colors.hover.light,
		},
		':is([data-pressed])': {
			background: THEME.colors.primary.light,
			color: THEME.colors.primary.dark,
			fontWeight: THEME.typography.fontWeights.semibold,
		},
	},
});
